import { useAuth } from "../../hooks";
import { SideMenuItem } from "./SideMenuItem";
import {
  RiHome5Line,
  RiRestaurantLine,
  RiUser3Line,
  RiMapPinLine,
  RiBankCardLine,
  RiShoppingBag3Line,
  RiLogoutBoxRLine,
  RiLoginBoxLine,
} from "react-icons/ri";
import { HiOutlineGiftTop } from "react-icons/hi2";
import { useLayout } from "../../context";

export const SideMenu: React.FC<{
  collapsed?: boolean;
  onLogout: () => void;
}> = ({ collapsed = false, onLogout }) => {
  const { isLoggedIn, isGuest } = useAuth();
  const { setActiveModal } = useLayout();

  return (
    <div className="left_menu">
      <ul>
        <SideMenuItem
          to={`/home`}
          icon={<RiHome5Line />}
          title="Home"
          collapsed={collapsed}
        />
        <SideMenuItem
          to={`/menu`}
          icon={<RiRestaurantLine />}
          title="Menus"
          collapsed={collapsed}
        />
        <SideMenuItem
          to={`/offer-and-rewards`}
          icon={<HiOutlineGiftTop />}
          title="Offers & Rewards"
          collapsed={collapsed}
        />

        {!isLoggedIn || isGuest ? (
          <>
            <SideMenuItem
              to={`#`}
              onClick={() => setActiveModal("login")}
              icon={<RiLoginBoxLine />}
              title="Login"
              collapsed={collapsed}
            />
          </>
        ) : (
          <>
            <SideMenuItem
              to={`/profile`}
              icon={<RiUser3Line />}
              title="Profile"
              collapsed={collapsed}
            />
            <SideMenuItem
              to={`/address`}
              icon={<RiMapPinLine />}
              title="My Address"
              collapsed={collapsed}
            />
            <SideMenuItem
              to={`/payments`}
              icon={<RiBankCardLine />}
              title="Payments"
              collapsed={collapsed}
            />
            <SideMenuItem
              to={`/orders`}
              icon={<RiShoppingBag3Line />}
              title="My Order"
              collapsed={collapsed}
            />
            <SideMenuItem
              to={`#`}
              onClick={onLogout}
              icon={<RiLogoutBoxRLine />}
              title="Logout"
              collapsed={collapsed}
            />
          </>
        )}
      </ul>
    </div>
  );
};
